import { useTranslation } from 'modules/queryBuilder/hooks/useTranslation';
import { CountFilterType } from 'modules/queryBuilder/types';
import { COUNT_FILTER_LABEL } from './constants';

export const useCountFilterSelectOptions = () => {
  const { t } = useTranslation();
  return Object.values(CountFilterType).map((type) => ({
    title: t(COUNT_FILTER_LABEL[type]),
    value: type,
  }));
};
